document.addEventListener('DOMContentLoaded', function() {
    Cart.init();
});

const Cart = {
    selectors: {
        "htmlEl": { selector: "html", type: "single", scope: "document" },
        "cartIcon": { selector: ".header-cart .cart-icon", type: "single", scope: "document" },
        "cartClose": { selector: ".close-cart", type: "single", scope: "document" },
        "wrapperOverlay": { selector: ".wrapper-overlay", type: "single", scope: "document" },
        "removeItemBtns": { selector: '.mini-products-list .btn-remove, .cart-list .btn-remove', type: 'all', scope: 'document'},
        "noItems": { selector: ".no-items", type: "single", scope: "document" },
        "hasItems": { selector: ".has-items", type: "single", scope: "document" },
        "loadingSpinner": { selector: ".icon-loading", type: "single", scope: "document" },
        "cartTemplate": { selector: ".cart-template", type: "single", scope: "document" },
        "quantityInputs": { selector: ".item-quantity", type: "all", scope: "document"},
        "addGiftBtns": { selector: ".gift-product-card button", type: "all", scope: "document" },
        "quickAddBtns": { selector: ".quick-add-to-cart", type: "all", scope: "document" },
        "hasAnyTiersBars": { selector: ".progress-bar-tiers", type: "all", scope: "document" },
        "multiplierProgressBar": { selector: ".progress-bar-multiplier", type: "single", scope: "document" },
        "progressFreeShippingBar": { selector: ".free_shipping_progress", type: "single", scope: "document" },
        "dropdownCart": { selector: "#dropdown-cart", type: "single", scope: "document" },
        "fullPageShippingEl": { selector: ".price.shipping-price", type: "single", scope: "document" },
        "sideBarShippingEl":  { selector: ".price-text.shipping-text", type: "single", scope: "document" }
    },
  
    init: async function() { 
        Utility.fetchEls(this.selectors, this);
        this.initEventListeners();
        this.promo = '';
        this.promoAmount = .5;
        this.parent;
        this.threshold;
        this.UPCHARGE_VARIANT_ID = '43392971997286'; // variant id for paddle customizations $5 upcharge


        if (this.cartTemplate) {
          this.parent = this.cartTemplate;
        } else {
          this.parent = this.dropdownCart;
        }
        
        // this.updateCart();        
    },
    initEventListeners: function() {
      const {htmlEl, cartIcon, cartClose, wrapperOverlay, removeItemBtns, quantityInputs, addGiftBtns, quickAddBtns } = this;

      if (cartIcon) {
        cartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          if (window.location.href.includes('selkirk.com/cart')) {
            return;
          }
          Utility.hideProgressBarPopup();
          htmlEl.classList.add('cart-show');
        });
      }
      
      if (cartClose) {
        cartClose.addEventListener('click', () => {
          Utility.restoreProgressBarPopup();
          htmlEl.classList.remove('cart-show');

          
        });
      }
      
      if (wrapperOverlay)  {
        wrapperOverlay.addEventListener('click', () => {
          Utility.restoreProgressBarPopup();
          if (htmlEl.classList.contains('cart-show')) {
            htmlEl.classList.remove('cart-show');
          }
        });
      }
      
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (htmlEl.classList.contains('cart-show')) {
            Utility.restoreProgressBarPopup();
            htmlEl.classList.remove('cart-show');
          }
        }
      });
      
      if (removeItemBtns) {
        removeItemBtns.forEach((btn) => {
          const item = btn.closest('.cart-product-item');
          btn.addEventListener('click', () => {
            this.removeFromCart(item);
          });
        });
      }

      if (quantityInputs) {
        quantityInputs.forEach((input) => {
          input.addEventListener('change', () => {

            const item = input.closest('.cart-product-item');
            const itemId = item.dataset.lineId;
            
            this.updateCartLineQuantity(itemId, input.value, item);
          });
        });
      }
      if (addGiftBtns) {
        addGiftBtns.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            this.addToCart(event);
          });
        });
      }
      if (quickAddBtns) {
        quickAddBtns.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            this.addToCart(event);
          });
        });
      }
    },
    getCartItems: async function() {
       try {
          const response = await fetch("/cart.js", {
              method: "GET",
          });
  
          if (!response.ok) throw new Error('Network response was not ok.');
          const cartData = await response.json();
       
          return cartData;
        } catch (error) {
            console.error('Error getting cart', error);
        }
    },
    
    removeFromCart: async function (item) {
      const { loadingSpinner } = this;
      loadingSpinner.style.display = 'block';

      // 1. Figure out which row number was clicked in the sidebar
      // Usually, the visual list matches Shopify's data list exactly.
      const listContainer = item.parentElement;
      const allRows = Array.from(listContainer.querySelectorAll('.cart-product-item'));
      const domIndex = allRows.indexOf(item); // 0-based visual index
      const variantId = item.dataset.productId;

      const upchargeEl = document.querySelector(`[data-product-id="${this.UPCHARGE_VARIANT_ID}"]`);
      const upchargeQtyEl = upchargeEl ? upchargeEl.querySelector('.item-quantity') : null;
      const currentUpchargeTotal = upchargeEl ? parseInt(upchargeQtyEl.value, 10) : 0;

      try {
        // 2. Get the real cart data from Shopify
        const cartData = await this.getCartItems();

        // 3. Find the correct line number to delete (Shopify uses 1-based indexes)
        let lineIndex = domIndex + 1;
        let cartItem = cartData.items[domIndex];

        // 4. Double check: Does the item at this row actually match the ID we clicked?
        // Sometimes "hidden" items (like insurance or auto-gifts) exist in the data but not the sidebar.
        // If that happens, the indexes won't match, and we might delete the wrong thing.
        if (!cartItem || String(cartItem.variant_id) !== String(variantId)) {
          console.warn("Cart Sync: The visual row didn't match the data. Searching the cart manually...");

          const hasCustomGrip = item.dataset.customGrip === 'true';

          // Safely grab the grip text from the HTML without crashing if the tag is missing
          const gripEl = item.querySelector('.option small');
          const gripValue = (hasCustomGrip && gripEl?.textContent)
            ? gripEl.textContent.replace('Custom Grip: ', '').trim()
            : null;

          // Manual Search: Find the item that matches the Variant ID AND the Grip property
          const foundIndex = cartData.items.findIndex(ci => {
            // Must match Variant ID
            if (String(ci.variant_id) !== String(variantId)) return false;

            // Must match the Grip Property
            const ciGrip = ci.properties?.['Custom Grip'];

            if (hasCustomGrip) {
              // If deleting a Custom Grip paddle, the cart item needs to have that text
              return ciGrip && gripValue && ciGrip.includes(gripValue);
            } else {
              // If deleting a Standard paddle, the cart item should NOT have that property
              return !ciGrip;
            }
          });

          if (foundIndex === -1) {
            console.error("Critical: Could not find this item in the cart data.");
            lineIndex = 0; // Prevent accidental deletion
            cartItem = null;
          } else {
            lineIndex = foundIndex + 1;
            cartItem = cartData.items[foundIndex];
          }
        }

        // 5. Delete the item
        if (cartItem && lineIndex > 0) {
          const quantityToRemove = cartItem.quantity;
          const hasCustomGrip = cartItem.properties &&
            cartItem.properties['Custom Grip'] &&
            cartItem.properties['Custom Grip'].trim() !== '';

          // IMPORTANT: Use 'line' (index) instead of 'id' (variant ID) here.
          // If we use ID, Shopify gets confused between the Standard and Custom versions 
          // because they share the same Variant ID, and it might delete the wrong one.
          await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: 0 })
          });

          // 6. Update the $5 Upcharge item
          if (hasCustomGrip && upchargeEl) {
            const upchargeKey = upchargeEl.dataset.lineId;
            // Subtract the quantity we just deleted from the total upcharges
            const newUpchargeQty = Math.max(0, currentUpchargeTotal - quantityToRemove);

            await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: upchargeKey, quantity: newUpchargeQty })
            });

            // Update the upcharge look immediately
            if (newUpchargeQty === 0) {
              upchargeEl.remove();
            } else {
              const upchargePriceEl = upchargeEl.querySelector('.price');
              const pricePerItem = parseFloat(upchargePriceEl.dataset.price);
              const totalPrice = pricePerItem * newUpchargeQty;
              upchargePriceEl.textContent = `$${(totalPrice / 100).toFixed(2)}`;
              upchargeQtyEl.value = newUpchargeQty;
            }
          }

          if (item) item.remove();
        }

      } catch (error) {
        console.error('Error removing item:', error);
      }

      this.updateCart();
      loadingSpinner.style.display = 'none';
    },

    updateCartLineQuantity: async function (key, quantity, item) {
      const { loadingSpinner } = this;
      loadingSpinner.style.display = 'block';

      // Make sure we have the DOM element to calculate positions
      if (!item && key) {
        item = document.querySelector(`.cart-product-item[data-line-id="${CSS.escape(key)}"]`);
      }

      if (!item) {
        console.error('Item DOM element not found.');
        loadingSpinner.style.display = 'none';
        return;
      }

      // 1. Identify Row Index
      const listContainer = item.parentElement;
      const allRows = Array.from(listContainer.querySelectorAll('.cart-product-item'));
      const domIndex = allRows.indexOf(item);
      const variantId = item.dataset.productId;

      const oldQuantity = parseInt(item.dataset.quantity, 10) || 0;
      const diff = quantity - oldQuantity;

      const upchargeEl = document.querySelector(`.cart-product-item[data-product-id="${this.UPCHARGE_VARIANT_ID}"]`);
      const upchargeQtyEl = upchargeEl ? upchargeEl.querySelector('.item-quantity') : null;
      const upchargeQty = upchargeEl ? parseInt(upchargeQtyEl.value, 10) : 0;
      const upchargePriceEl = upchargeEl ? upchargeEl.querySelector('.price') : null;

      if (quantity > 1000) quantity = 1000;
      if (quantity < 0 || isNaN(quantity)) quantity = 0;

      // If they typed 0, just use the remove function (it has better math for the upcharge)
      if (Number(quantity) === 0) {
        this.removeFromCart(item);
        return;
      }

      try {
        // 2. Get real cart data
        const cartData = await this.getCartItems();

        // 3. Find correct line index
        let lineIndex = domIndex + 1;
        let cartItem = cartData.items[domIndex];

        // 4. Double check: Ensure the visual row matches the data row
        if (!cartItem || String(cartItem.variant_id) !== String(variantId)) {
          console.warn("Cart Update: Visual index mismatch. Searching manually...");

          const hasCustomGrip = item.dataset.customGrip === 'true';

          const gripEl = item.querySelector('.option small');
          const gripValue = (hasCustomGrip && gripEl?.textContent)
            ? gripEl.textContent.replace('Custom Grip: ', '').trim()
            : null;

          // Manual Search (same logic as removeFromCart)
          const foundIndex = cartData.items.findIndex(ci => {
            if (String(ci.variant_id) !== String(variantId)) return false;
            const ciGrip = ci.properties?.['Custom Grip'];

            if (hasCustomGrip) {
              return ciGrip && gripValue && ciGrip.includes(gripValue);
            } else {
              return !ciGrip;
            }
          });

          if (foundIndex === -1) {
            console.error("Critical: Could not find this item in the cart data.");
            lineIndex = 0;
            cartItem = null;
          } else {
            lineIndex = foundIndex + 1;
            cartItem = cartData.items[foundIndex];
          }
        }

        // 5. Execute Update
        if (cartItem && lineIndex > 0) {
          const hasCustomGrip = cartItem.properties &&
            cartItem.properties['Custom Grip'] &&
            cartItem.properties['Custom Grip'].trim() !== '';

          // Use 'line' index to ensure we update the specific row, not just any row with this ID
          await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: quantity })
          });

          // 6. Sync Upcharge
          if (hasCustomGrip && diff !== 0 && upchargeEl) {
            const upchargeKey = upchargeEl.dataset.lineId;
            const newUpchargeQty = Math.max(0, upchargeQty + diff);

            await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: upchargeKey, quantity: newUpchargeQty })
            });

            if (newUpchargeQty === 0) {
              upchargeEl.remove();
            } else {
              const pricePerItem = parseFloat(upchargePriceEl.dataset.price);
              const totalPrice = pricePerItem * newUpchargeQty;
              upchargePriceEl.textContent = `$${(totalPrice / 100).toFixed(2)}`;
              upchargeQtyEl.value = newUpchargeQty;
            }
          }

          // Update the screen immediately
          item.dataset.quantity = quantity;
          const itemPriceEl = item.querySelector('.price');
          const pricePerItem = parseFloat(itemPriceEl.dataset.price);
          const totalPrice = pricePerItem * quantity;
          itemPriceEl.textContent = `$${(totalPrice / 100).toFixed(2)}`;

          const itemComparePriceEl = item.querySelector('.compare-price');
          if (itemComparePriceEl) {
            const comparePrice = parseFloat(itemPriceEl.dataset.comparePrice);
            const totalComparePrice = comparePrice * quantity;
            itemComparePriceEl.textContent = `$${(totalComparePrice / 100).toFixed(2)}`;
          }
        }

      } catch (error) {
        console.error('Error updating quantity:', error);
      }

      this.updateCart();
      loadingSpinner.style.display = 'none';
    },

    updateProgressMeterTiers: function (total) {
      const totalCents = Math.round(parseFloat(total) * 100);
      const DOT_FILL_MS = 420; // animation duration for dot fill

      const bars = document.querySelectorAll(".progress-bar-tiers");
      if (!bars.length) return;

      bars.forEach(function (bar) {
        const ctaEl = bar.querySelector(".progress-bar-tiers__cta");
        //if (ctaEl && !bar.dataset.ctaDefault) bar.dataset.ctaDefault = ctaEl.textContent;

        const progressMessage = bar.querySelector(".free_shipping_message");
        const steps = bar.querySelectorAll(".progress-bar-tiers__step");
        const segBars = bar.querySelectorAll(".progress-bar-tiers__seg-bar");
        if (!progressMessage || !steps.length || !segBars.length) return;

        const tiersCents = (bar.dataset.tiers || "").split(",").map(v => parseInt(v.trim(), 10)).filter(n => !isNaN(n));
        const rewards = (bar.dataset.rewards || "").split(",").map(v => v.trim());
        if (!tiersCents.length) return;

        let unlockedIndex = -1;
        for (let i = 0; i < tiersCents.length; i++) {
          if (totalCents >= tiersCents[i]) unlockedIndex = i; else break;
        }
        const nextIndex = unlockedIndex + 1;

        // newly unlocked steps
        const prevUnlocked = parseInt(bar.dataset.prevUnlocked || "-1", 10);
        if (unlockedIndex > prevUnlocked) {
          for (let j = prevUnlocked + 1; j <= unlockedIndex; j++) {
            const step = steps[j];
            if (step) triggerTierUnlockAnimation(step);
          }
        }
        bar.dataset.prevUnlocked = String(unlockedIndex);

        // compute next dot fractional fill
        let dotFillPct = 0;
        if (nextIndex > 0 && nextIndex < tiersCents.length) {
          const prevCap = tiersCents[nextIndex - 1];
          const nextCap = tiersCents[nextIndex];
          if (nextCap > prevCap && totalCents > prevCap) {
            const within = totalCents - prevCap;
            const span = nextCap - prevCap;
            dotFillPct = (within / span) * 100;
            if (dotFillPct < 0) dotFillPct = 0;
            if (dotFillPct > 100) dotFillPct = 100;
          }
        }

        // update dot states
        steps.forEach(function (step, idx) {
          const dot = step.querySelector(".progress-bar-tiers__dot");
          if (idx <= unlockedIndex) {
            step.classList.add("is-unlocked");
            step.classList.remove("is-filling");
            if (dot) dot.style.removeProperty("--dot-fill");
          } else {
            step.classList.remove("is-unlocked");
            if (idx === nextIndex && dotFillPct > 0) {
              step.classList.add("is-filling");
              animateTierDotFill(dot, dotFillPct, DOT_FILL_MS);
            } else {
              step.classList.remove("is-filling");
              if (dot) dot.style.setProperty("--dot-fill", "0%");
            }
          }
        });

        // fill segments up to the next dot
        segBars.forEach(function (segBar, i) {
          const shouldBeFull = i < nextIndex && i < tiersCents.length - 1;
          segBar.style.transform = shouldBeFull ? "scaleX(1)" : "scaleX(0)";
        });

        // heading + hint handling
        if (nextIndex >= tiersCents.length) {
          // Reached goal text
          //if (ctaEl) ctaEl.innerHTML = "You unlocked all gifts";
          if (progressMessage) progressMessage.textContent = "";
        } else {
          if (ctaEl && bar.dataset.ctaDefault) ctaEl.textContent = bar.dataset.ctaDefault;
          const remaining = Math.max(0, tiersCents[nextIndex] - totalCents);
          if (remaining > 0) {
            const raw = rewards[nextIndex] || "";
            const main = (raw.split(" | ")[0] || "").trim();
            const perk = (main.split(" + ").pop() || main).trim();
            const dollars = (remaining / 100).toFixed(2);
            progressMessage.innerHTML = "Only <strong>$" + dollars + "</strong> away from <strong>" + perk + "</strong>!";
          } else {
            progressMessage.textContent = "";
          }
        }
      });
      
      function animateTierDotFill(dot, targetPct, duration) {
        if (!dot) return;
        const style = dot.style;
        const current = getTierDotCurrentFill(style);
        const from = isNaN(current) ? 0 : current;
        const to = Math.max(0, Math.min(100, targetPct));
        if (Math.abs(to - from) < 0.5) {
          style.setProperty("--dot-fill", to.toFixed(2) + "%");
          return;
        }
        const start = performance.now();
        function raf(t) {
          const p = Math.min(1, (t - start) / duration);
          // ease-in-out quad
          const eased = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
          const val = from + (to - from) * eased;
          style.setProperty("--dot-fill", val.toFixed(2) + "%");
          if (p < 1) requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
      }
      function getTierDotCurrentFill(style) {
        const v = style.getPropertyValue("--dot-fill");
        if (!v) return NaN;
        const n = parseFloat(v.replace("%", ""));
        return isNaN(n) ? NaN : n;
      }
      function triggerTierUnlockAnimation(step) {
        if (!step) return;
        step.classList.add("just-unlocked");
        setTimeout(function () {
          step.classList.remove("just-unlocked");
        }, 600);
      }
    },


    updateProgressBarMultiplier: function(total) {
      const { multiplierProgressBar, parent } = this;

      const progressMeter = parent.querySelector('.progress-bar-multiplier-meter');
      const progressMessage = parent.querySelector('.progress-bar-multiplier-message');
      const unlockedGift = parent.querySelector('.simple-unlocked-gift');
      const earnedMultiplierDisplay = parent.querySelector('.simple-bonus-multiplier');

      if (!progressMeter || !progressMessage || !unlockedGift) {
        console.error('Progress bar elements not found.');
        return;
      }

      const goalAmount = parseFloat(multiplierProgressBar.dataset.goal);
      const rewardAmount = parseFloat(multiplierProgressBar.dataset.reward);
      let previousMultiplier = parseInt(earnedMultiplierDisplay.textContent) || 0;
      let earnedMultiplier = Math.floor(total / goalAmount);

      let earnedAmount = Math.floor(total / goalAmount) * rewardAmount;
      let remainingAmount = goalAmount - (total % goalAmount);

      if (remainingAmount === goalAmount) {
        remainingAmount = 0;
      }

      let progressPercentage = (total % goalAmount) / goalAmount * 100;
      if (progressPercentage > 100) progressPercentage = 100;

      progressMeter.style.width = `${progressPercentage}%`;

      let formattedEarnedAmount = earnedAmount.toFixed(0);
      let formattedRemainingAmount = remainingAmount % 1 === 0 ? remainingAmount.toFixed(0) : remainingAmount.toFixed(2);

      if (earnedMultiplier > previousMultiplier) {
        earnedMultiplierDisplay.classList.add("pop-bonus"); // Add animation class
        setTimeout(() => {
          earnedMultiplierDisplay.classList.remove("pop-bonus"); // Remove class after animation
        }, 500);
      }

      earnedMultiplierDisplay.textContent = `${earnedMultiplier}x`;

      if (total >= goalAmount) {
        unlockedGift.style.display = "block";
        unlockedGift.innerHTML = `You've earned <strong>$${formattedEarnedAmount}</strong> in Selkirk Bonus Bucks!<br> Keep spending to earn more!`;
        progressMessage.style.display = "none";
      } else {
        progressMessage.style.display = "block";
        progressMessage.innerHTML = `Only <strong>$${formattedRemainingAmount}</strong> away from your next <strong>$${rewardAmount.toFixed(0)}</strong> in Selkirk Bonus Bucks!`;
        unlockedGift.style.display = "none";
      }
    },

    updateProgressBarFreeShipping: function(total) {
      const { parent } = this;

      const container = parent.querySelector('.free_shipping_progress');
      if (!container) return;

      // show the bar as soon as there's at least one cent in the cart,
      // hide it again if the cart is emptied
      if (total > 0) {
        container.style.display = 'flex'
      } else {
        container.style.display = 'none'
        return
      }
    
      const threshold = parseFloat(container.dataset.threshold);
      this.threshold = threshold;
      const meter = container.querySelector('.progress-meter-free-shipping');
      const remainingP = container.querySelector('.free-ship-msg-remaining');
      const unlockedP = container.querySelector('.free-ship-msg-unlocked');
    
      const percentage = Math.min(total / threshold * 100, 100);
      const remaining = Math.max(threshold - total, 0);
      const isUnlocked = total >= threshold;

      // toggle color
      meter.classList.toggle('filled', isUnlocked)
      meter.style.width = `${percentage}%`

      if (isUnlocked) {
        remainingP.style.display = 'none'
        unlockedP.style.display = 'flex'
      } else {
        remainingP.style.display = 'flex'
        remainingP.textContent = `You’re $${remaining.toFixed(2)} away from free shipping!`
        unlockedP.style.display  = 'none'
      }
    },

    updateCart: async function() {
      const { noItems, hasItems, cartTemplate, multiplierProgressBar, hasAnyTiersBars, progressFreeShippingBar, promo} = this;
      const cartData = await this.getCartItems();
      if (cartData.item_count !== 0) {
        // Unlock if there's any non-Recovery/Slide item in the cart
        const triggerQty = cartData.items.reduce((sum, it) => {
          const t = (it.title || '').toLowerCase();
          const isRecoveryOrSlide = t.includes('recovery shoe') || t.includes('slide');
          return isRecoveryOrSlide ? sum : sum + it.quantity;
        }, 0);

        // Sidebar upsell block show/hide
        // DISABLE PROMO LOGIC TEMPORARILY
        // const productsContainer = document.querySelector('.cart-sidebar-products');
        // if (productsContainer) {
        //   if (triggerQty > 0) {
        //     productsContainer.classList.add('upsell-promo');
        //   } else {
        //     productsContainer.classList.remove('upsell-promo');
        //   }
        // }

        // Adjust displayed prices in the sidebar cart when promo is unlocked
        if (promo) {
          const cartLineEls = document.querySelectorAll('.cart-product-item');

          cartLineEls.forEach((el) => {
            const id = el.dataset.lineId;
            const cartItem = cartData.items.find((ci) => ci.id.toString() === id);
            if (!cartItem) return;

            const t = (cartItem.title || '').toLowerCase();
            const isRecoveryOrSlide = t.includes('recovery shoe') || t.includes('slide');
            const priceWrap = el.querySelector('.cart-collateral');
            if (!priceWrap) return;

            const unit = cartItem.original_price; // cents
            const qty = cartItem.quantity;
            const originalTotal = unit * qty;

            const renderDiscount = (finalTotalCents) => {
              priceWrap.innerHTML = `
              <span class="compare-price">
                $${(originalTotal / 100).toFixed(2)}
              </span>
              <span class="price on-sale"
                    data-price="${finalTotalCents}"
                    data-compare-price="${unit}">
                $${(finalTotalCents / 100).toFixed(2)}
              </span>`;
            };

            const renderRegular = () => {
              const compareAt = cartItem.variant_compare_at_price || 0;
              const hasCompare = compareAt && compareAt > unit;
              if (hasCompare) {
                priceWrap.innerHTML = `
                <span class="compare-price">
                  $${((compareAt * qty) / 100).toFixed(2)}
                </span>
                <span class="price on-sale"
                      data-price="${unit}"
                      data-compare-price="${compareAt}">
                  $${((unit * qty) / 100).toFixed(2)}
                </span>`;
              } else {
                priceWrap.innerHTML = `
                <span class="price"
                      data-price="${unit}"
                      data-compare-price="${compareAt}">
                  $${((unit * qty) / 100).toFixed(2)}
                </span>`;
              }
            };

            // If unlocked, ALL Recovery/Slide qty are 50% off
            if (triggerQty > 0 && isRecoveryOrSlide) {
              const finalTotal = Math.floor(unit * qty * this.promoAmount); // 50%
              renderDiscount(finalTotal);
            } else {
              renderRegular();
            }
          });
        }

        this.updateCartCount(cartData.item_count);
      } else {
        this.updateCartTotal(0);
        this.updateCartCount(0);
        this.updateShipping(0);
        const productsContainer = document.querySelector('.cart-sidebar-products');
        if (productsContainer) productsContainer.classList.remove('upsell-promo');
      }

      // Exclude gift cards from progress logic
      const excludedProductIds = ['4178164580406', '7231994069094'];

      const totalGiftCards = cartData.items.reduce((sum, item) => {
        // Check if the item's ID exists in our array of excluded IDs
        if (excludedProductIds.includes(item.product_id.toString())) {
          return sum + (item.price * item.quantity);
        }
        return sum;
      }, 0);
      
      const total = cartData.total_price - totalGiftCards;

      this.updateCartTotal((cartData.total_price / 100).toFixed(2));
      this.updateShipping(cartData.total_price);

      if (hasAnyTiersBars) {
        this.updateProgressMeterTiers((total / 100).toFixed(2));
      }
      if (multiplierProgressBar) {
        this.updateProgressBarMultiplier((total / 100).toFixed(2));
      }
      if (progressFreeShippingBar) {
        this.updateProgressBarFreeShipping((total / 100).toFixed(2));
      }

      // Sidebar-only empty/filled toggles
      if (!cartTemplate) {
        if (cartData.item_count === 0) {
          noItems.style.display = 'block';
          hasItems.style.display = 'none';
        } else {
          noItems.style.display = 'none';
          hasItems.style.display = 'block';
        }
      }
    },

    
    updateCartTotal: function(total) {
      const {cartTemplate} = this;
      if (cartTemplate) {
         // main cart page
        const priceEls = document.querySelectorAll('.th_cart_total_price');
        priceEls.forEach((el) => {
          el.textContent = `$${total}`;
        });
      } else {
        // sidebar  cart
        const priceEl = document.querySelector('.total-section .price-text');
        priceEl.textContent = `$${total}`;
      }
    },

    updateShipping: function(total) {
      const { fullPageShippingEl, sideBarShippingEl } = this;
      // this.threshold comes from the cart progress bar threshold value in the customizer
      const threshold = this.threshold ? this.threshold * 100 : 5500;
      const shippingEl = fullPageShippingEl || sideBarShippingEl; 

      if (shippingEl) {
        shippingEl.textContent = total > threshold ? 'FREE!' : 'Calculated at checkout';
      }
    },
    
    updateCartCount: function(count) {
      const cartCount = document.querySelectorAll('.cartCount');
      cartCount.forEach((el) => {
        el.textContent = count;
      });
    },

    addItemToSidebarCart: async function(id, quantity, customGrip, handle, display, key) {
        const {noItems, hasItems, promo, quantityInputs } = this;

        // Check if this item is already visually in the sidebar using the Key
        const existingItem = document.querySelector(`.cart-product-item[data-line-id="${key}"]`);

        if (existingItem && !customGrip) {
          // If it exists visually, we don't want to add a second row.
          // Instead, we update the quantity of the existing row.
          const qtyInput = existingItem.querySelector('.item-quantity');
          let currentQty = 0;
          if ( qtyInput ) {
            currentQty = parseInt(qtyInput.value || 0, 10);
          }
          const newTotalQty = currentQty + parseInt(quantity, 10);

          if ( qtyInput ) {
            // Update the input value
            qtyInput.value = newTotalQty;
          }
          
          // Trigger the update function to recalculate prices and totals
          await this.updateCartLineQuantity(key, newTotalQty, existingItem);

          // Ensure the cart is open if requested
          if (display) {
            const html = document.querySelector('html');
            Utility.hideProgressBarPopup();
            html.classList.add('cart-show');
          }
          return; // return here so we don't create a duplicate row
        }

        const cartData = await this.getCartItems();
        const cartItem = cartData.items.find(item => item.id == key);
        let productData = await Utility.fetchProductDataAjax(handle);

        const variant  = productData.variants.find((variant) => variant.id == id);

        const readonlyVariants = ["43392971997286", "42119516553318", "44177423663206"];
        const isReadonly = readonlyVariants.includes(variant.id.toString());
        
        const container = document.querySelector('.mini-products-list');
        const item = document.createElement('li');
        item.classList.add('item');
        item.classList.add('cart-product-item');

        // Use unique Line Item Key to prevent duplicate IDs in DOM
        item.id = `cart-item-${key}`;

        item.setAttribute('data-product-id', variant.id);
        item.setAttribute('data-line-id', key);
        item.setAttribute('data-quantity', quantity);

        let imageSrc = cartItem?.image || variant.featured_image?.src || productData.featured_image;
        if (!cartItem?.image && ProductPage.productDetails?.variantId == variant.id) {
          const activeImg = ProductPage.selected?.querySelector('img');
          imageSrc = activeImg?.src || ProductPage.productDetails.image || imageSrc;
        } 
        
        item.innerHTML = `
        <a href="${productData.url}?variant=${variant.id}" class="product-image">
        <img src="${imageSrc}" alt="${productData.title} - ${variant.title}">
        </a>
        <div class="product-details">
        <a class="product-title" href="${productData.url}?variant=${variant.id}">
            <span>
            ${productData.title}
            </span>
        </a>
        ${!variant.title.includes('Default') ? 
            `<div class="option">
            <small>${variant.title}</small>
        </div>` : ''}
        
        <div class="cart-collateral">
          ${(
            promo && productData.title.toLowerCase().includes(promo) ? 
              `<span class="compare-price">
                  $${parseFloat(variant.price / 100).toFixed(2)}
              </span>
              <span class="price on-sale" data-price="${variant.price * this.promoAmount}" data-compare-price="${variant.price}">
                $${parseFloat(variant.price / 100 * this.promoAmount).toFixed(2)}
              </span>` : 
              `<span class="price" data-price="${variant.price}">
                $${parseFloat(variant.price / 100).toFixed(2)}
              </span>`
          )}
        </div>
        <div class="quantity">
          ${isReadonly ? 
            `<input class="item-quantity item-quantity-new" type="text" value="${quantity}" readonly>` : 
            `<input class="item-quantity item-quantity-new" name="quantity" id="updates${variant.id}" data-qtt-id1="quantity${variant.id}" value="${quantity}" type="number">`

          }
          <span class="error-message-input"></span>
        </div>
        </div>
        <a href="javascript:void(0)" title="Remove This Item" class="btn-remove-new btn-remove">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#000000" d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>
        </a>
        `;
        container.prepend(item);

        if (customGrip) {
          item.dataset.customGrip = 'true';
          const variantTitleEl = item.querySelector('.product-details .option');
          const gripDiv = document.createElement('div');
          gripDiv.classList.add('option');
          gripDiv.innerHTML = `<small>Custom Grip: ${customGrip.replace(' (BTOG)', '')}</small>`;
          variantTitleEl.insertAdjacentElement('afterend', gripDiv);

          const existingUpchargeEl = container.querySelector(
            `.cart-product-item[data-product-id="${this.UPCHARGE_VARIANT_ID}"]`
          );

          if (existingUpchargeEl) {
            // Update displayed quantity & price visually
            const qtyEl = existingUpchargeEl.querySelector('.item-quantity');
            const priceEl = existingUpchargeEl.querySelector('.price');
            const unitPrice = parseFloat(priceEl.dataset.price);

            const newQty = parseInt(qtyEl.value, 10) + parseInt(quantity, 10);
            qtyEl.value = newQty;
            priceEl.textContent = `$${((unitPrice * newQty) / 100).toFixed(2)}`;
          } else {
            // Add a new visible upcharge line
            const upchargeEl = document.createElement('li');
            upchargeEl.classList.add('item', 'cart-product-item');
            upchargeEl.setAttribute('data-product-id', this.UPCHARGE_VARIANT_ID);
            upchargeEl.setAttribute('data-line-id', this.UPCHARGE_VARIANT_ID);
            upchargeEl.setAttribute('data-quantity', quantity);

            upchargeEl.innerHTML = `
              <div class="product-image no-image"></div>
              <div class="product-details">
                <span class="product-title">Paddle Customization</span>
                <div class="cart-collateral">
                  <span class="price" data-price="500">$${(5 * quantity).toFixed(2)}</span>
                </div>
                <div class="quantity">
                  <input class="item-quantity" type="text" value="${quantity}" readonly>
                </div>
              </div>
            `;

            container.prepend(upchargeEl);
          }
        }

        // attach event listeners to newly created buttons
        const newBtn = container.querySelector('.btn-remove-new');
        newBtn.addEventListener('click', () => {
          this.removeFromCart(item);
        });

        const newQuantity = container.querySelector('.item-quantity-new');
        newQuantity.addEventListener('change', async () => {
          await this.updateCartLineQuantity(key, newQuantity.value, item);
        });

        hasItems.style.display = 'block';
        noItems.style.display = 'none';

      if (display) {
        const html = document.querySelector('html');
        Utility.hideProgressBarPopup();
        html.classList.add('cart-show');
      }
    },

    findLineItem: async function(variantId, grip) {
      const cartData = await this.getCartItems();

      const lineItems = cartData.items.filter((item) => item.variant_id == variantId);
      let item;
      if (grip) {
        item = lineItems.find((item) => item.properties['Custom Grip'] == grip);
      } else {
        item = lineItems.find((item) => Object.keys(item.properties).length === 0);
      }
      if (item) {
        return { key: item.id, quantity: item.quantity };
      } else {
        return null;
      }
    },


    // addGiftsToCart: async function (e) {
    //   const addToCartBtn = e.target;
    //   console.log('CART: adding gifts');
    //   console.log('CART: add to cart btn text', addToCartBtn.textContent.trim());
    //   if (addToCartBtn.textContent.trim() == 'Remove') {
    //     console.log('CART: removing');
    //     const products = document.querySelectorAll('.cart-product-item');
    //     products.forEach((product) => {
    //       if (addToCartBtn.dataset.keys.includes(product.dataset.key)) {
    //         this.removeFromCart(product);
    //       }
    //     });
    //     const allButtons = document.querySelectorAll('button[data-ids]');
    //     allButtons.forEach((btn) => {
    //       btn.classList.remove('disabled');
    //       btn.textContent = 'Add to Cart';
    //       btn.disabled = false;
    //     });
    
    //     // Change the clicked button's text to "Remove"
    //     addToCartBtn.dataset.keys = ''; // Store as a string
    //     return;
    //   }
    //   const keys = [];
    //   const idsString = addToCartBtn.dataset.ids; // Get the data-ids value
    //   const handlesString = addToCartBtn.dataset.handles; // Get the data-ids value
    //   const handles = handlesString.split(','); // Parse handles as an array
    //   const tier = addToCartBtn.dataset.tier; // Get the data-tier value
    //   if (!idsString || !tier) return;
    
    //   // Parse IDs, including backup IDs
    //   const items = idsString.split(',').map((idPair, index) => {
    //     const [primaryId, backup] = idPair.split(':backup=');
    //     return {
    //       primaryId: primaryId.trim(),
    //       backupId: backup ? backup.trim() : null,
    //       handle: handles[index].trim(), // Add handle to the object
    //     };
    //   });
        
    //   let allSuccessful = true;
    
    //   // Process each item
    //   for (const item of items) {
    //     let success = false;
    //     let currentId = item.primaryId;
    
    //     // Attempt to add primary or backup ID
    //     while (!success && currentId) {
    //       const formParams = `items[][id]=${currentId}&items[][quantity]=1&items[][properties][_GIFT]=TIER_${tier}`;
    //       try {
    //         const response = await fetch("/cart/add.js", {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/x-www-form-urlencoded",
    //           },
    //           body: formParams,
    //         });
    
    //         if (!response.ok) {
    //           console.error(`Failed to add item with ID: ${currentId}`);
    //           throw new Error(`Item with ID ${currentId} failed.`);
    //         }
    
    //         const data = await response.json();
    //         console.log(`Item with ID ${currentId} added successfully:`, data);
    //         success = true; // Mark as successful
    //         keys.push(data.items[0].key);
    //         console.log('CART: keys', keys);
    //         this.handleAddSuccess(currentId, addToCartBtn.textContent, false, false, e, null, item.handle, 1, null, null, data.items[0].key);
    //       } catch (error) {
    //         console.error("Add to cart error:", error);
    //         // Switch to backup ID if available and not already attempted
    //         if (currentId === item.primaryId && item.backupId) {
    //           currentId = item.backupId;
    //         } else {
    //           // No backup or retry failed, exit loop
    //           currentId = null;
    //         }
    //       }
    //     }
    
    //     if (!success) {
    //       console.error(`Failed to add both primary and backup IDs for item:`, item);
    //       allSuccessful = false;
    //       alert(`Some items could not be added to the cart.`);
    //     }
    //   }
    
    //   // If all items were successfully added, update button styles and text
    //   if (allSuccessful) {
    //     const allButtons = document.querySelectorAll('button[data-ids]');
    //     allButtons.forEach((btn) => {
    //       btn.classList.add('disabled');
    //       btn.textContent = 'Remove Gift to Claim';
    //       btn.disabled = true;
    //     });
    
    //     // Change the clicked button's text to "Remove"
    //     addToCartBtn.textContent = 'Remove';
    //     addToCartBtn.disabled = false;
    //     addToCartBtn.dataset.keys = keys.join(','); // Store as a string
    //   }
    // },
    
    addToCart: async function (e) {
      let handle;
      let card = false;
      const ogBtnText = e.target.textContent;
      e.preventDefault();

      const form = e.target.closest('.cart');

      if (window.innerWidth < 1200) {
        e.target.textContent = 'Adding...';
      } else {
        e.target.textContent = 'Adding to Cart...';
      }
      e.target.disabled = true;

      const modal = e.target.dataset.modal === 'true';
      let id;
      let quantity = 1;
      let formParams;
      let customGrip;
      let productCard;
      let hasCustomGrip = false;

      if (!form) {
        // For quick add buttons (no form available)
        productCard = e.target.closest('.product-card');
        id = productCard.querySelector('.product-id-input').value;
        quantity = 1; // Default quantity for quick add buttons
        formParams = new URLSearchParams({
          id,
          quantity,
        });
        handle = e.target.dataset.handle;
      } else {
        // Create FormData object from the form
        const formData = new FormData(form);

        // Sanitization Logic: Handle Duplicate Inputs
        // Get ALL inputs with this name
        const rawGripInputs = formData.getAll('properties[Custom Grip]');

        // Find the one that actually has a value (ignores the blank ghost input)
        const normalizedGrip = rawGripInputs.reverse().find(rawInput => {
          if (!rawInput) return false;

          let cleanedInput = rawInput.trim();
          // Remove Zero Width Spaces and other invisible characters
          cleanedInput = cleanedInput.replace(/[\u200B-\u200D\uFEFF]/g, '');

          return cleanedInput.length > 0 && cleanedInput !== 'undefined' && cleanedInput !== 'null';
        }) || '';

        // Rebuild params cleanly
        formParams = new URLSearchParams(formData);

        // DELETE the conflicting property
        formParams.delete('properties[Custom Grip]');

        // Add back ONLY the valid value (if one exists)
        if (normalizedGrip) {
          formParams.set('properties[Custom Grip]', normalizedGrip);
        }

        id = formParams.get('id');
        customGrip = normalizedGrip;
        hasCustomGrip = !!customGrip;
        quantity = parseFloat(formParams.get('quantity'));

        if (form.classList.contains('card-cart')) {
          card = true;
          handle = form.querySelector('.quick-add').dataset.handle;
        } else {
          handle = e.target.dataset.handle;
        }
      }

      if (e.target.dataset.promo && this.promo) {
        formParams.append('properties[_cartPromo]', e.target.dataset.promo);
      }

      const itemInCart = await this.findLineItem(id, customGrip);

      if (itemInCart) {
        if (id.includes('44177423663206')) {
            window.location.href = '/cart';
            return;
        }
        
        const key = itemInCart.key;
        const oldQuantity = parseFloat(itemInCart.quantity);
        const newQuantity = oldQuantity + quantity;
        try {
          // updateCartLineQuantity handles both the main item and the upcharge sync.
          await this.updateCartLineQuantity(key, newQuantity);

          this.handleAddSuccess(id, ogBtnText, modal, card, e, newQuantity, handle, quantity, customGrip, key);
          window.PromoModal.onAddSuccess({ variantId: id, handle: handle });
        } catch (error) {
          console.error('PDP: error adding to cart', error);
        }
      } else {
        try {
          const bodyString = formParams.toString();

          const response = await fetch("/cart/add.js", {
            method: "POST",
            body: bodyString,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            },
          });

          if (!response.ok) throw new Error('Network response was not ok.');

          const responseData = await response.json();
          // Add the customization upcharge variant if grip selected
          if (hasCustomGrip) {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json",
              },
              body: new URLSearchParams({
                id: this.UPCHARGE_VARIANT_ID,
                quantity: quantity
              }),
            });
          }

          this.handleAddSuccess(id, ogBtnText, modal, card, e, null, handle, quantity, customGrip, responseData.id);
          window.PromoModal.onAddSuccess({ variantId: id, handle: handle });
        } catch (error) {
          console.error('PDP: error adding to cart', error);
          // Handle the error as necessary
        }
      }
      const giftCardModal = document.querySelector('.send-as-gift-form');
      const modalBg = document.querySelector('.modal-background');
      if (giftCardModal) {
        giftCardModal.style.display = 'none';
        modalBg.style.display = 'none';
      }
      this.updateCart();
    },
    handleAddSuccess: function(id, ogBtnText, modal, card, e, newQuantity, handle, quantity, customGrip, key) {
      // if (window.innerWidth < 1200) {
        const quickView = document.querySelector('#quickview-modal');
        const modalBg = document.querySelector('.modal-background');
        e.target.textContent = ogBtnText;
        if (modal) {
          quickView.style.display = 'none';
          modalBg.style.display = 'none';
        }
        if (newQuantity) {
          const itemQuantity = document.querySelector(`#updates${id}`);
          if (itemQuantity) {
            itemQuantity.value = newQuantity;
          }
          const html = document.querySelector('html');
          html.classList.add('cart-show');
        } else {
          this.addItemToSidebarCart(id, quantity, customGrip, handle, true, key);
        }
        e.target.disabled = false;
        this.updateCart();
      // } else {
      //   if (!card) {
      //     e.target.textContent = ogBtnText;
      //     window.location.href = '/cart';
      //     return;
      //   } else {
      //     e.target.textContent = 'Added to Cart';
      //     this.addItemToSidebarCart(formParams.toString(), handle, false, key);
      //   }
      // }
    }
};